// import React, { useEffect, useState } from "react";
// import { useOutletContext } from "react-router-dom";
// import { Pagination } from "react-bootstrap";
// import ViewOrderDetails from "./ViewOrderDetails";
// import "./ServitorSite.css";

// const CompleteOrders = () => {
//   const { servitor } = useOutletContext();
//   const [completedOrders, setCompletedOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const ordersPerPage = 10;

//   useEffect(() => {
//     if (servitor && servitor.Id) {
//       // Fetch completed orders from backend for logged-in servitor
//       fetch(`http://localhost:4001/servitor-completed-orders/${servitor.Id}`)
//         .then((res) => res.json())
//         .then((orderData) => {
//           setCompletedOrders(orderData);
//           setLoading(false);
//         })
//         .catch((error) => {
//           console.error("Error fetching completed orders:", error);
//           setLoading(false);
//         });
//     }
//   }, [servitor]);

//   const handleViewDetails = (order) => {
//     setSelectedOrder(order);
//   };

//   const handleBackToOrders = () => {
//     setSelectedOrder(null);
//   };

//   // Pagination logic
//   const indexOfLastOrder = currentPage * ordersPerPage;
//   const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
//   const currentOrders = completedOrders.slice(indexOfFirstOrder, indexOfLastOrder);
//   const totalPages = Math.ceil(completedOrders.length / ordersPerPage);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const tableStyle = {
//     width: "100%",
//     borderCollapse: "collapse",
//     marginBottom: "20px",
//   };

//   const thStyle = {
//     border: "1px solid #ddd",
//     padding: "8px",
//     backgroundColor: "#f2f2f2",
//     textAlign: "left",
//   };

//   const tdStyle = {
//     border: "1px solid #ddd",
//     padding: "8px",
//     textAlign: "left",
//   };

//   if (loading) return <p>Loading...</p>;

//   const content = selectedOrder ? (
//     <ViewOrderDetails order={selectedOrder} onBack={handleBackToOrders} />
//   ) : (
//     <>
//       <h2 className="servitorsite-welcome-heading">Completed Orders</h2>
//       {completedOrders.length === 0 ? (
//         <p>No completed orders found.</p>
//       ) : (
//         <>
//           <table style={tableStyle}>
//             <thead>
//               <tr>
//                 <th style={thStyle}>Order ID</th>
//                 <th style={thStyle}>Service</th>
//                 <th style={thStyle}>Price</th>
//                 <th style={thStyle}>Date</th>
//                 <th style={thStyle}>Time</th>
//                 <th style={thStyle}>City</th>
//                 <th style={thStyle}>Address</th>
//                 <th style={thStyle}>Status</th>
//                 <th style={thStyle}>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentOrders.map((order, index) => (
//                 <tr key={index}>
//                   <td style={tdStyle}>{order.Id}</td>
//                   <td style={tdStyle}>
//                     {order.Service?.services_name || "N/A"}
//                   </td>
//                   <td style={tdStyle}>${order.price}</td>
//                   <td style={tdStyle}>{new Date(order.date).toLocaleDateString()}</td>
//                   <td style={tdStyle}>{order.time}</td>
//                   <td style={tdStyle}>
//                     {order.City || order.usercity || "Unknown"}
//                   </td>
//                   <td style={tdStyle}>
//                     {order.Address || order.useraddress || "Unknown"}
//                   </td>
//                   <td style={tdStyle}>{order.status}</td>
//                   <td style={tdStyle}>
//                     <button
//                       style={{
//                         backgroundColor: "#10b981",
//                         color: "#fff",
//                         border: "none",
//                         padding: "5px 10px",
//                         borderRadius: "5px",
//                         cursor: "pointer",
//                       }}
//                       onClick={() => handleViewDetails(order)}
//                     >
//                       View Details
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//           <Pagination>
//             <Pagination.First
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//             />
//             <Pagination.Prev
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//             />
//             {[...Array(totalPages)].map((_, index) => (
//               <Pagination.Item
//                 key={index + 1}
//                 active={index + 1 === currentPage}
//                 onClick={() => handlePageChange(index + 1)}
//               >
//                 {index + 1}
//               </Pagination.Item>
//             ))}
//             <Pagination.Next
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//             />
//             <Pagination.Last
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//             />
//           </Pagination>
//         </>
//       )}
//     </>
//   );

//   return <>{content}</>;
// };

// export default CompleteOrders;



// ***** Checked all okay (25-6-25) ***** //

// import React, { useEffect, useState } from "react";
// import { useNavigate, useOutletContext } from "react-router-dom";
// import { Pagination } from "react-bootstrap";
// import ViewOrderDetails from "./ViewOrderDetails";
// import "./ServitorSite.css";

// const CompleteOrders = () => {
//   const { servitor } = useOutletContext();
//   const [completedOrders, setCompletedOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const navigate = useNavigate();

//   const [currentPage, setCurrentPage] = useState(1);
//   const ordersPerPage = 10;

//   useEffect(() => {
//     if (servitor && servitor.Id) {
//       // Fetch completed orders for the logged-in servitor.
//       // Make sure the backend returns an array even if no orders are found.
//       fetch(`http://localhost:4001/servitor-completed-orders/${servitor.Id}`)
//         .then((res) => res.json())
//         .then((orderData) => {
//           // If orderData is not an array, default to an empty array.
//           const ordersArray = Array.isArray(orderData) ? orderData : [];
//           setCompletedOrders(ordersArray);
//           setLoading(false);
//         })
//         .catch((error) => {
//           console.error("Error fetching completed orders:", error);
//           setCompletedOrders([]); // set to empty array on error
//           setLoading(false);
//         });
//     }
//   }, [servitor]);

//   const handleViewDetails = (order) => {
//     // setSelectedOrder(order);
//     navigate(`/servitor/orders/${order.order_number}`);
//   };

//   const handleBackToOrders = () => {
//     setSelectedOrder(null);
//   };

//   // Pagination calculations
//   const indexOfLastOrder = currentPage * ordersPerPage;
//   const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
//   const currentOrders = completedOrders.slice(indexOfFirstOrder, indexOfLastOrder);
//   const totalPages = Math.ceil(completedOrders.length / ordersPerPage);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   // Inline styles for table
//   // const tableStyle = {
//   //   width: "100%",
//   //   borderCollapse: "collapse",
//   //   marginBottom: "20px",
//   // };
//   // const thStyle = {
//   //   border: "1px solid #ddd",
//   //   padding: "8px",
//   //   backgroundColor: "#f2f2f2",
//   //   textAlign: "left",
//   // };
//   // const tdStyle = {
//   //   border: "1px solid #ddd",
//   //   padding: "8px",
//   //   textAlign: "left",
//   // };

//   const formatDate = (dateStr) => new Date(dateStr).toLocaleDateString();

//   if (loading) return <p>Loading...</p>;

//   const content = selectedOrder ? (
//     <ViewOrderDetails order={selectedOrder} onBack={handleBackToOrders} />
//   ) : (
//     <>
//       <h2 className="servitorsite-welcome-heading">Completed Orders</h2>
//       {completedOrders.length === 0 ? (
//         <p>No completed orders found.</p>
//       ) : (
//         <>
//           {/* <table style={tableStyle}>
//             <thead>
//               <tr>
//                 <th style={thStyle}>Order ID</th>
//                 <th style={thStyle}>Service</th>
//                 <th style={thStyle}>Price</th>
//                 <th style={thStyle}>Date</th>
//                 <th style={thStyle}>Time</th>
//                 <th style={thStyle}>City</th>
//                 <th style={thStyle}>Address</th>
//                 <th style={thStyle}>Status</th>
//                 <th style={thStyle}>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentOrders.map((order, index) => (
//                 <tr key={index}>
//                   <td style={tdStyle}>{order.order_number}</td>
//                   <td style={tdStyle}>
//                     {order.Service?.services_name || "N/A"}
//                   </td>
//                   <td style={tdStyle}>${order.price}</td>
//                   <td style={tdStyle}>{formatDate(order.date)}</td>
//                   <td style={tdStyle}>{order.time}</td>
//                   <td style={tdStyle}>
//                     {order.City || order.usercity || "Unknown"}
//                   </td>
//                   <td style={tdStyle}>
//                     {order.Address || order.useraddress || "Unknown"}
//                   </td>
//                   <td style={tdStyle}>{order.status}</td>
//                   <td style={tdStyle}>
//                     <button
//                       style={{
//                         backgroundColor: "#10b981",
//                         color: "#fff",
//                         border: "none",
//                         padding: "5px 10px",
//                         borderRadius: "5px",
//                         cursor: "pointer",
//                       }}
//                       onClick={() => handleViewDetails(order)}
//                     >
//                       View Details
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table> */}

//       <div className="complete-orders-table-wrapper">
//         <table className="complete-orders-table">
//           <thead>
//             <tr>
//               <th className="complete-orders-th">Order ID</th>
//               <th className="complete-orders-th">Service</th>
//               <th className="complete-orders-th">Price</th>
//               <th className="complete-orders-th">Date</th>
//               <th className="complete-orders-th">Time</th>
//               <th className="complete-orders-th">City</th>
//               <th className="complete-orders-th">Address</th>
//               <th className="complete-orders-th">Status</th>
//               <th className="complete-orders-th">Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentOrders.map((order, index) => (
//               <tr key={index}>
//                 <td className="complete-orders-td">{order.order_number}</td>
//                 <td className="complete-orders-td">
//                   {order.Service?.services_name || "N/A"}
//                 </td>
//                 <td className="complete-orders-td">{order.price} Tk</td>
//                 <td className="complete-orders-td">{formatDate(order.date)}</td>
//                 <td className="complete-orders-td">{order.time}</td>
//                 <td className="complete-orders-td">
//                   {order.City || order.usercity || "Unknown"}
//                 </td>
//                 <td className="complete-orders-td">
//                   {order.Address || order.useraddress || "Unknown"}
//                 </td>
//                 <td className="complete-orders-td">{order.status}</td>
//                 <td className="complete-orders-td">
//                   <button className="complete-orders-btn" onClick={() => handleViewDetails(order)}>
//                     View Details
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//           <Pagination>
//             <Pagination.First
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//             />
//             <Pagination.Prev
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//             />
//             {[...Array(totalPages)].map((_, index) => (
//               <Pagination.Item
//                 key={index + 1}
//                 active={index + 1 === currentPage}
//                 onClick={() => handlePageChange(index + 1)}
//               >
//                 {index + 1}
//               </Pagination.Item>
//             ))}
//             <Pagination.Next
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//             />
//             <Pagination.Last
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//             />
//           </Pagination>
//         </>
//       )}
//     </>
//   );

//   return <>{content}</>;
// };

// export default CompleteOrders;


// ***** Upper code Checked all okay (25-6-25) ***** //






// ***** Add Translate EN BN (25-6-25) ***** //

// import React, { useEffect, useState } from "react";
// import { useNavigate, useOutletContext } from "react-router-dom";
// import { Pagination } from "react-bootstrap";
// import ViewOrderDetails from "./ViewOrderDetails";
// import { useTranslation } from "react-i18next";
// import "./ServitorSite.css";

// const CompleteOrders = () => {
//   const { t } = useTranslation("servitor");

//   const { servitor } = useOutletContext();
//   const [completedOrders, setCompletedOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const navigate = useNavigate();

//   const [currentPage, setCurrentPage] = useState(1);
//   const ordersPerPage = 10;

//   useEffect(() => {
//     if (servitor && servitor.Id) {
//       // Fetch completed orders for the logged-in servitor.
//       // Make sure the backend returns an array even if no orders are found.
//       fetch(`http://localhost:4001/servitor-completed-orders/${servitor.Id}`)
//         .then((res) => res.json())
//         .then((orderData) => {
//           // If orderData is not an array, default to an empty array.
//           const ordersArray = Array.isArray(orderData) ? orderData : [];
//           setCompletedOrders(ordersArray);
//           setLoading(false);
//         })
//         .catch((error) => {
//           console.error("Error fetching completed orders:", error);
//           setCompletedOrders([]); // set to empty array on error
//           setLoading(false);
//         });
//     }
//   }, [servitor]);

//   const handleViewDetails = (order) => {
//     // setSelectedOrder(order);
//     navigate(`/servitor/orders/${order.order_number}`);
//   };

//   const handleBackToOrders = () => {
//     setSelectedOrder(null);
//   };

//   // Pagination calculations
//   const indexOfLastOrder = currentPage * ordersPerPage;
//   const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
//   const currentOrders = completedOrders.slice(indexOfFirstOrder, indexOfLastOrder);
//   const totalPages = Math.ceil(completedOrders.length / ordersPerPage);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const formatDate = (dateStr) => new Date(dateStr).toLocaleDateString();

//   // if (loading) return <p>Loading...</p>;
//   if (loading) return <p>{t("common.loading")}</p>;

//   const content = selectedOrder ? (
//     <ViewOrderDetails order={selectedOrder} onBack={handleBackToOrders} />
//   ) : (
//     <>
//       {/* <h2 className="servitorsite-welcome-heading">Completed Orders</h2> */}
//       <h2 className="servitorsite-welcome-heading">{t("completeOrders.heading")}</h2>
//       {completedOrders.length === 0 ? (
//         // <p>No completed orders found.</p>
//         <p>{t("completeOrders.noOrders")}</p>
//       ) : (
//         <>
//       <div className="complete-orders-table-wrapper">
//         <table className="complete-orders-table">
//           <thead>
//             <tr>
//               {/* <th className="complete-orders-th">Order ID</th>
//               <th className="complete-orders-th">Service</th>
//               <th className="complete-orders-th">Price</th>
//               <th className="complete-orders-th">Date</th>
//               <th className="complete-orders-th">Time</th>
//               <th className="complete-orders-th">City</th>
//               <th className="complete-orders-th">Address</th>
//               <th className="complete-orders-th">Status</th>
//               <th className="complete-orders-th">Actions</th> */}

//               <th className="complete-orders-th">{t("completeOrders.orderId")}</th> {/* NEW: Translated */}
//                   <th className="complete-orders-th">{t("completeOrders.service")}</th> {/* NEW: Translated */}
//                   <th className="complete-orders-th">{t("completeOrders.price")}</th> {/* NEW: Translated */}
//                   <th className="complete-orders-th">{t("completeOrders.date")}</th> {/* NEW: Translated */}
//                   <th className="complete-orders-th">{t("completeOrders.time")}</th> {/* NEW: Translated */}
//                   <th className="complete-orders-th">{t("completeOrders.city")}</th> {/* NEW: Translated */}
//                   <th className="complete-orders-th">{t("completeOrders.address")}</th> {/* NEW: Translated */}
//                   <th className="complete-orders-th">{t("completeOrders.status")}</th> {/* NEW: Translated */}
//                   <th className="complete-orders-th">{t("completeOrders.actions")}</th> {/* NEW: Translated */}

//             </tr>
//           </thead>
//           <tbody>
//             {currentOrders.map((order, index) => (
//               <tr key={index}>
//                 <td className="complete-orders-td">{order.order_number}</td>
//                 <td className="complete-orders-td">
//                   {order.Service?.services_name || "N/A"}
//                 </td>
//                 <td className="complete-orders-td">{order.price} Tk</td>
//                 <td className="complete-orders-td">{formatDate(order.date)}</td>
//                 <td className="complete-orders-td">{order.time}</td>
//                 <td className="complete-orders-td">
//                   {order.City || order.usercity || "Unknown"}
//                 </td>
//                 <td className="complete-orders-td">
//                   {order.Address || order.useraddress || "Unknown"}
//                 </td>
//                 <td className="complete-orders-td">{order.status}</td>
//                 <td className="complete-orders-td">
//                   <button className="complete-orders-btn" onClick={() => handleViewDetails(order)} aria-label={t("completeOrders.viewDetails")}>
//                     {/* View Details */}
//                     {t("completeOrders.viewDetails")}
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//           <Pagination>
//             <Pagination.First
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//               aria-label={t("completeOrders.firstPage")}
//             />
//             <Pagination.Prev
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//               aria-label={t("completeOrders.previousPage")}
//             />
//             {[...Array(totalPages)].map((_, index) => (
//               <Pagination.Item
//                 key={index + 1}
//                 active={index + 1 === currentPage}
//                 onClick={() => handlePageChange(index + 1)}
//                 aria-label={`${t("completeOrders.page")} ${index + 1}`}
//               >
//                 {index + 1}
//               </Pagination.Item>
//             ))}
//             <Pagination.Next
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//               aria-label={t("completeOrders.nextPage")}
//             />
//             <Pagination.Last
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//               aria-label={t("completeOrders.lastPage")}
//             />
//           </Pagination>
//         </>
//       )}
//     </>
//   );

//   return <>{content}</>;
// };

// export default CompleteOrders;

// ***** Upper code is all working with translator (7-7-25) ***** //






// ***** design update and checked okay ***** //

// import React, { useEffect, useState } from "react";
// import { useNavigate, useOutletContext } from "react-router-dom";
// import { Pagination } from "react-bootstrap";
// import ViewOrderDetails from "./ViewOrderDetails";
// import { useTranslation } from "react-i18next";
// import "./OrdersStyle.css"; // CHANGE: Updated CSS file from 'ServitorSite.css' to 'OrdersStyle.css' for specific styling

// const CompleteOrders = () => {
//   const { t } = useTranslation("servitor");
//   const { servitor } = useOutletContext();
//   const [completedOrders, setCompletedOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedOrder, setSelectedOrder] = useState(null); // CHANGE: No longer used directly in render due to navigation-based details view
//   const navigate = useNavigate();
//   const [currentPage, setCurrentPage] = useState(1);
//   const ordersPerPage = 10;

//   useEffect(() => {
//     if (servitor && servitor.Id) {
//       fetch(`http://localhost:4001/servitor-completed-orders/${servitor.Id}`)
//         .then((res) => res.json())
//         .then((orderData) => {
//           const ordersArray = Array.isArray(orderData) ? orderData : [];
//           setCompletedOrders(ordersArray);
//           setLoading(false);
//         })
//         .catch((error) => {
//           console.error("Error fetching completed orders:", error);
//           setCompletedOrders([]);
//           setLoading(false);
//         });
//     }
//   }, [servitor]);

//   const handleViewDetails = (order) => {
//     navigate(`/servitor/orders/${order.order_number}`); // CHANGE: Removed setSelectedOrder; now navigates to a new route for order details
//   };

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const formatDate = (dateStr) => new Date(dateStr).toLocaleDateString();

//   // NEW: Added truncateAddress function to shorten long addresses for better display, especially in mobile view
//   const truncateAddress = (address, maxLength = 50) => {
//     return address.length > maxLength ? address.substring(0, maxLength) + "..." : address;
//   };

//   // NEW: Added variables for pagination summary
//   const indexOfLastOrder = currentPage * ordersPerPage;
//   const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
//   const currentOrders = completedOrders.slice(indexOfFirstOrder, indexOfLastOrder);
//   const totalPages = Math.ceil(completedOrders.length / ordersPerPage);
//   const totalOrders = completedOrders.length;
//   const startOrder = indexOfFirstOrder + 1;
//   const endOrder = Math.min(indexOfLastOrder, totalOrders);

//   // CHANGE: Updated loading message with a specific class for styling
//   if (loading) return <p className="completeorders-loading">{t("common.loading")}</p>;

//   return (
//     // NEW: Wrapped content in a container div for better layout control
//     <div className="completeorders-container">
//       {/* NEW: Separated header into its own div for better alignment and styling */}
//       <div className="completeorders-header">
//         <h1 className="completeorders-title">{t("completeOrders.heading")}</h1> {/* CHANGE: Changed from h2 to h1 and updated class */}
//       </div>

//       {selectedOrder ? (
//         // CHANGE: Simplified ViewOrderDetails rendering; onBack removed as navigation handles it
//         <ViewOrderDetails order={selectedOrder} onBack={() => setSelectedOrder(null)} />
//       ) : completedOrders.length === 0 ? (
//         // CHANGE: Added class for no-orders message styling
//         <p className="completeorders-empty">{t("completeOrders.noOrders")}</p>
//       ) : (
//         <>
//           {/* NEW: Added content wrapper for desktop and mobile views */}
//           <div className="completeorders-content">
//             {/* NEW: Added desktop-specific wrapper for table view */}
//             <div className="completeorders-desktop">
//               <div className="completeorders-table-wrapper">
//                 <table className="completeorders-table">
//                   <thead>
//                     <tr>
//                       <th className="completeorders-th">{t("completeOrders.orderId")}</th>
//                       <th className="completeorders-th">{t("completeOrders.service")}</th>
//                       <th className="completeorders-th">{t("completeOrders.price")}</th>
//                       {/* CHANGE: Combined Date and Time into a single column */}
//                       <th className="completeorders-th">{t("completeOrders.dateTime")}</th>
//                       {/* CHANGE: Combined City and Address into a single Location column */}
//                       <th className="completeorders-th">{t("completeOrders.location")}</th>
//                       <th className="completeorders-th">{t("completeOrders.status")}</th>
//                       <th className="completeorders-th">{t("completeOrders.actions")}</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {currentOrders.map((order, index) => (
//                       // CHANGE: Added class for row styling
//                       <tr key={index} className="completeorders-row">
//                         <td className="completeorders-td">{order.order_number}</td>
//                         <td className="completeorders-td">{order.Service?.services_name || "N/A"}</td>
//                         {/* CHANGE: Added specific class for price styling */}
//                         <td className="completeorders-td completeorders-price">{order.price} Tk</td>
//                         <td className="completeorders-td">
//                           {/* CHANGE: Combined date and time in one cell with separate divs for styling */}
//                           <div>{formatDate(order.date)}</div>
//                           <div className="completeorders-time">{order.time}</div>
//                         </td>
//                         <td className="completeorders-td">
//                           {/* CHANGE: Combined city and address in one cell with separate divs */}
//                           <div className="completeorders-city">{order.City || order.usercity || "Unknown"}</div>
//                           <div className="completeorders-address">{order.Address || order.useraddress || "Unknown"}</div>
//                         </td>
//                         {/* CHANGE: Added class for status styling */}
//                         <td className="completeorders-td">
//                           <span className="completeorders-status">{order.status}</span>
//                         </td>
//                         <td className="completeorders-td">
//                           <button
//                             className="completeorders-btn"
//                             onClick={() => handleViewDetails(order)}
//                             aria-label={t("completeOrders.viewDetails")}
//                           >
//                             {t("completeOrders.viewDetails")}
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>

//             {/* NEW: Added mobile-specific card view for responsive design */}
//             <div className="completeorders-mobile">
//               {currentOrders.map((order, index) => (
//                 <div key={index} className="completeorders-card">
//                   <div className="completeorders-card-header">
//                     <div>
//                       <h3 className="completeorders-card-title">{order.order_number}</h3>
//                       <p className="completeorders-card-service">{order.Service?.services_name || "N/A"}</p>
//                     </div>
//                     <div className="completeorders-card-right">
//                       <p className="completeorders-card-price">{order.price} Tk</p>
//                       <span className="completeorders-status">{order.status}</span>
//                     </div>
//                   </div>
//                   <div className="completeorders-card-body">
//                     <div className="completeorders-card-item">
//                       <span className="completeorders-card-label">{t("completeOrders.dateTime")}</span>
//                       <span className="completeorders-card-value">
//                         {formatDate(order.date)} at {order.time}
//                       </span>
//                     </div>
//                     <div className="completeorders-card-item">
//                       <span className="completeorders-card-label">{t("completeOrders.location")}</span>
//                       <div className="completeorders-card-value">
//                         <div>{order.City || order.usercity || "Unknown"}</div>
//                         <div className="completeorders-card-address">
//                           {truncateAddress(order.Address || order.useraddress || "Unknown")} {/* NEW: Applied truncateAddress */}
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <button
//                     className="completeorders-btn"
//                     onClick={() => handleViewDetails(order)}
//                     aria-label={t("completeOrders.viewDetails")}
//                   >
//                     {t("completeOrders.viewDetails")}
//                   </button>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* NEW: Added pagination summary to show range of orders displayed */}
//           <div className="completeorders-summary">
//             {t("completeOrders.paginationSummary", { startOrder, endOrder, totalOrders })}
//           </div>

//           {/* CHANGE: Simplified pagination by removing numbered pages and keeping only First/Prev/Next/Last */}
//           <div className="completeorders-pagination">
//             <Pagination>
//               <Pagination.First
//                 onClick={() => handlePageChange(1)}
//                 disabled={currentPage === 1}
//                 aria-label={t("completeOrders.firstPage")}
//               >
//                 {/* CHANGE: Removed text to make pagination buttons icon-only for First/Last */}
//               </Pagination.First>
//               <Pagination.Prev
//                 onClick={() => handlePageChange(currentPage - 1)}
//                 disabled={currentPage === 1}
//                 aria-label={t("completeOrders.previousPage")}
//               >
//                 {t("completeOrders.previousPage")}
//               </Pagination.Prev>
//               <Pagination.Next
//                 onClick={() => handlePageChange(currentPage + 1)}
//                 disabled={currentPage === totalPages}
//                 aria-label={t("completeOrders.nextPage")}
//               >
//                 {t("completeOrders.nextPage")}
//               </Pagination.Next>
//               <Pagination.Last
//                 onClick={() => handlePageChange(totalPages)}
//                 disabled={currentPage === totalPages}
//                 aria-label={t("completeOrders.lastPage")}
//               >
//                 {/* CHANGE: Removed text to make pagination buttons icon-only for First/Last */}
//               </Pagination.Last>
//             </Pagination>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default CompleteOrders;






// ***** Update with new design of order tabke view (7-7-25) an dpage view memorize ***** //
// import React, { useEffect, useState } from "react";
// import {
//   useNavigate,
//   useOutletContext,
//   useLocation, // to read/write ?page
// } from "react-router-dom";
// import { Pagination } from "react-bootstrap";
// import ViewOrderDetails from "./ViewOrderDetails";
// import { useTranslation } from "react-i18next";
// import "./CompleteOrders.css";

// const CompleteOrders = () => {
//   const { t } = useTranslation("servitor");
//   const { servitor } = useOutletContext();
//   const navigate = useNavigate();

//   // grab current ?page= value (default 1)
//   const location = useLocation();
//   const params = new URLSearchParams(location.search);
//   const initialPage = parseInt(params.get("page") || "1", 10);

//   const { pathname, search } = location;
//   const navigateRef = React.useRef(navigate);

//   // initialize from URL instead of always 1
//   const [currentPage, setCurrentPage] = useState(initialPage);

//   const [completedOrders, setCompletedOrders] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [selectedOrder, setSelectedOrder] = useState(null);

//   const ordersPerPage = 10;

//   // Fetch orders
//   useEffect(() => {
//     if (servitor && servitor.Id) {
//       fetch(`http://localhost:4001/servitor-completed-orders/${servitor.Id}`)
//         .then((res) => res.json())
//         .then((orderData) => {
//           const ordersArray = Array.isArray(orderData) ? orderData : [];
//           setCompletedOrders(ordersArray);
//           setLoading(false);
//         })
//         .catch(() => {
//           setCompletedOrders([]);
//           setLoading(false);
//         });
//     }
//   }, [servitor]);

//   // Whenever page changes, push it into the URL
//   useEffect(() => {
//     const params = new URLSearchParams(search);
//     params.set("page", currentPage);
//     navigateRef.current(
//       { pathname, search: params.toString() },
//       { replace: true }
//     );
//   }, [currentPage, pathname, search]);

//   // unchanged
//   const handleViewDetails = (order) => {
//     // preserve your current-location (with ?page) in state
//     navigate(`/servitor/orders/${order.order_number}`, {
//       state: { from: location },
//     });
//   };

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   // const formatDate = (dateStr) => new Date(dateStr).toLocaleDateString();
//   const formatDate = (dateStr) => {
//    const d = new Date(dateStr);
//    const day = d.getDate();
//    const month = d.toLocaleString("default", { month: "long" });
//    const year = d.getFullYear();
//    return `${day}-${month}-${year}`;
//  };

//   // guard against undefined
//   const truncateAddress = (address = "", maxLength = 25) => {
//     return String(address).length > maxLength
//       ? String(address).substring(0, maxLength) + "..."
//       : String(address);
//   };

//   // Pagination calculations
//   const indexOfLastOrder = currentPage * ordersPerPage;
//   const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
//   const currentOrders = completedOrders.slice(
//     indexOfFirstOrder,
//     indexOfLastOrder
//   );
//   const totalPages = Math.ceil(completedOrders.length / ordersPerPage);
//   const totalOrders = completedOrders.length;
//   const startOrder = indexOfFirstOrder + 1;
//   const endOrder = Math.min(indexOfLastOrder, totalOrders);

//   if (loading)
//     return <p className="completeorders-loading">{t("common.loading")}</p>;

//   return (
//     <div className="completeorders-container">
//       <div className="completeorders-header">
//         <h1 className="completeorders-title">{t("completeOrders.heading")}</h1>
//       </div>

//       {selectedOrder ? (
//         <ViewOrderDetails
//           order={selectedOrder}
//           onBack={() => setSelectedOrder(null)}
//         />
//       ) : completedOrders.length === 0 ? (
//         <p className="completeorders-empty">{t("completeOrders.noOrders")}</p>
//       ) : (
//         <>
//           <div className="completeorders-content">
//             <div className="completeorders-desktop">
//               <div className="completeorders-table-wrapper">
//                 <table className="completeorders-table">
//                   <thead>
//                     <tr>
//                       <th className="completeorders-th">
//                         {t("completeOrders.orderId")}
//                       </th>
//                       <th className="completeorders-th">
//                         {t("completeOrders.service")}
//                       </th>
//                       <th className="completeorders-th">
//                         {t("completeOrders.price")}
//                       </th>
//                       <th className="completeorders-th">
//                         {t("completeOrders.dateTime")}
//                       </th>
//                       <th className="completeorders-th">
//                         {t("completeOrders.location")}
//                       </th>
//                       <th className="completeorders-th">
//                         {t("completeOrders.status")}
//                       </th>
//                       <th className="completeorders-th">
//                         {t("completeOrders.actions")}
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {currentOrders.map((order, index) => (
//                       <tr key={index} className="completeorders-row">
//                         <td className="completeorders-td">
//                           {order.order_number}
//                         </td>
//                         <td className="completeorders-td">
//                           {order.Service?.services_name || "N/A"}
//                         </td>
//                         <td className="completeorders-td completeorders-price">
//                           {order.price} Tk
//                         </td>
//                         <td className="completeorders-td">
//                           <div>{formatDate(order.date)}</div>
//                           <div className="completeorders-time">
//                             {order.time}
//                           </div>
//                         </td>
//                         <td className="completeorders-td">
//                           <div className="completeorders-city">
//                             {order.City || order.usercity || "Unknown"}
//                           </div>
//                           <div className="completeorders-address">
//                             {order.Address || order.useraddress || "Unknown"}
//                           </div>
//                         </td>
//                         <td className="completeorders-td">
//                           <span className="completeorders-status">
//                             {order.status}
//                           </span>
//                         </td>
//                         <td className="completeorders-td">
//                           <button
//                             className="completeorders-btn"
//                             onClick={() => handleViewDetails(order)}
//                           >
//                             {t("completeOrders.viewDetails")}
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>

//             <div className="completeorders-mobile">
//               {currentOrders.map((order, index) => (
//                 <div key={index} className="completeorders-card">
//                   <div className="completeorders-card-header">
//                     <div>
//                       <h3 className="completeorders-card-title">
//                         {order.order_number}
//                       </h3>
//                       <p className="completeorders-card-service">
//                         {order.Service?.services_name || "N/A"}
//                       </p>
//                     </div>
//                     <div className="completeorders-card-right">
//                       <p className="completeorders-card-price">
//                         {order.price} Tk
//                       </p>
//                       <span className="completeorders-status">
//                         {order.status}
//                       </span>
//                     </div>
//                   </div>
//                   <div className="completeorders-card-body">
//                     <div className="completeorders-card-item">
//                       <span className="completeorders-card-label">
//                         {t("completeOrders.dateTime")}
//                       </span>
//                       <span className="completeorders-card-value">
//                         {formatDate(order.date)} at {order.time}
//                       </span>
//                     </div>
//                     <div className="completeorders-card-item">
//                       <span className="completeorders-card-label">
//                         {t("completeOrders.location")}
//                       </span>
//                       <div className="completeorders-card-value">
//                         <div>{order.City || order.usercity || "Unknown"}</div>
//                         <div className="completeorders-card-address">
//                           {truncateAddress(
//                             order.Address || order.useraddress || "Unknown"
//                           )}
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <button
//                     className="completeorders-btn"
//                     onClick={() => handleViewDetails(order)}
//                   >
//                     {t("completeOrders.viewDetails")}
//                   </button>
//                 </div>
//               ))}
//             </div>
//           </div>

//           <div className="completeorders-summary">
//             {t("completeOrders.paginationSummary", {
//               startOrder,
//               endOrder,
//               totalOrders,
//             })}
//           </div>

//           <div className="completeorders-pagination">
//             <Pagination>
//               <Pagination.First
//                 onClick={() => handlePageChange(1)}
//                 disabled={currentPage === 1}
//               />
//               <Pagination.Prev
//                 onClick={() => handlePageChange(currentPage - 1)}
//                 disabled={currentPage === 1}
//               >
//                 {t("completeOrders.previousPage")}
//               </Pagination.Prev>
//               <Pagination.Next
//                 onClick={() => handlePageChange(currentPage + 1)}
//                 disabled={currentPage === totalPages}
//               >
//                 {t("completeOrders.nextPage")}
//               </Pagination.Next>
//               <Pagination.Last
//                 onClick={() => handlePageChange(totalPages)}
//                 disabled={currentPage === totalPages}
//               />
//             </Pagination>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default CompleteOrders;






// ***** New Design and Update (18-Sep-2025) ***** //

import React, { useEffect, useState, useMemo } from "react";
import { useNavigate, useOutletContext, useLocation } from "react-router-dom";
import { Pagination } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./CompleteOrders.css";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// NEW: bring the two UIs here (used to live on ViewOrderDetails)
import ServitorReviewModal from "./ServitorReviewModal";
import ServitorReceiptGenerator from "./ServitorReceipt/ServitorReceiptGenerator";
// adjust the path to wherever you put dateformat.js
import { formatDate as fmtDate, formatYearMonth } from "../dateTimefrontpart";

// icons
import {
  // FaMoneyBillWave,
  // FaClipboardCheck,
  // FaChartLine,
  // FaDownload,
  FaStar,
} from "react-icons/fa";
import { URL } from "../../config";
import Loader from "../../Components/LoaderSpin/Loader";

const CompleteOrders = () => {
  const { t } = useTranslation("servitor");
  const { servitor } = useOutletContext();
  const navigate = useNavigate();

  // sync ?page
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const initialPage = parseInt(params.get("page") || "1", 10);
  const { pathname, search } = location;
  const navigateRef = React.useRef(navigate);

  const [currentPage, setCurrentPage] = useState(initialPage);
  const [completedOrders, setCompletedOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  // NEW: local modals
  const [reviewOrder, setReviewOrder] = useState(null); // order object to rate
  const [receiptOrder, setReceiptOrder] = useState(null); // order object to download receipt

  const ordersPerPage = 10;

  // ===== Filters =====
  const [filterType, setFilterType] = useState("all"); // all|today|yesterday|thisMonth|lastMonth|range|month
  const [startDate, setStartDate] = useState(""); // YYYY-MM-DD
  const [endDate, setEndDate] = useState(""); // YYYY-MM-DD
  const [selectedMonth, setSelectedMonth] = useState(""); // YYYY-MM

  // Prefer completion date if present
  const getOrderDate = (o) => {
    const raw =
      o.completed_at || o.completedAt || o.completedAt?.date || o.date;
    return raw ? new Date(raw) : null;
  };

  const isSameDay = (a, b) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();

  // Fetch orders
  useEffect(() => {
    if (servitor && servitor.Id) {
      fetch(`${URL}/servitor-completed-orders/${servitor.Id}`)
        .then((res) => res.json())
        .then((orderData) => {
          const arr = Array.isArray(orderData) ? orderData : [];
          setCompletedOrders(arr);
          setLoading(false);
        })
        .catch(() => {
          setCompletedOrders([]);
          setLoading(false);
        });
    }
  }, [servitor]);

  // keep ?page in URL
  useEffect(() => {
    const p = new URLSearchParams(search);
    p.set("page", currentPage);
    navigateRef.current({ pathname, search: p.toString() }, { replace: true });
  }, [currentPage, pathname, search]);

  const handlePageChange = (n) => setCurrentPage(n);

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    const day = d.getDate();
    const month = d.toLocaleString("default", { month: "long" });
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const truncateAddress = (address = "", maxLength = 25) =>
    String(address).length > maxLength
      ? String(address).substring(0, maxLength) + "..."
      : String(address);

  const hasServitorReviewed = (o) =>
    Boolean(o?.servitor_reviewed ?? o?.hasReview);
  // Filter
  const filteredOrders = useMemo(() => {
    if (!Array.isArray(completedOrders)) return [];
    const today = new Date();
    const startOfMonth = (d) => new Date(d.getFullYear(), d.getMonth(), 1);
    const endOfMonth = (d) =>
      new Date(d.getFullYear(), d.getMonth() + 1, 0, 23, 59, 59, 999);

    return completedOrders.filter((o) => {
      const d = getOrderDate(o);
      if (!d) return false;
      switch (filterType) {
        case "today":
          return isSameDay(d, today);
        case "yesterday": {
          const y = new Date(today);
          y.setDate(today.getDate() - 1);
          return isSameDay(d, y);
        }
        case "thisMonth": {
          const s = startOfMonth(today);
          const e = endOfMonth(today);
          return d >= s && d <= e;
        }
        case "lastMonth": {
          const lm = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          const s = startOfMonth(lm);
          const e = endOfMonth(lm);
          return d >= s && d <= e;
        }
        case "month": {
          if (!selectedMonth) return true;
          const [yy, mm] = selectedMonth.split("-").map(Number);
          const s = new Date(yy, mm - 1, 1);
          const e = new Date(yy, mm, 0, 23, 59, 59, 999);
          return d >= s && d <= e;
        }
        case "range": {
          if (!startDate || !endDate) return true;
          const s = new Date(startDate);
          const e = new Date(endDate);
          e.setHours(23, 59, 59, 999);
          return d >= s && d <= e;
        }
        default:
          return true;
      }
    });
  }, [completedOrders, filterType, startDate, endDate, selectedMonth]);

  // Summary
  const totalEarnings = useMemo(
    () => filteredOrders.reduce((sum, o) => sum + (Number(o.price) || 0), 0),
    [filteredOrders]
  );
  const completedCount = filteredOrders.length;

  // Pagination on filtered list
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = filteredOrders.slice(
    indexOfFirstOrder,
    indexOfLastOrder
  );
  const totalPages = Math.ceil(filteredOrders.length / ordersPerPage) || 1;
  const totalOrders = filteredOrders.length;
  const startOrder = totalOrders ? indexOfFirstOrder + 1 : 0;
  const endOrder = Math.min(indexOfLastOrder, totalOrders);

  // ===== Stable Datepicker Input (doesn't close while navigating months) =====

  const MONTH_FULL = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const pad2 = (n) => String(n).padStart(2, "0");

  function parseYMD(ymd /* "YYYY-MM-DD" */) {
    if (!ymd) return null;
    const m = String(ymd).match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return null;
    return { y: +m[1], m: +m[2], d: +m[3] };
  }
  function daysInMonth(y, m /*1-12*/) {
    return new Date(y, m, 0).getDate();
  }
  function firstDow(y, m /*1-12*/) {
    // 0=Sun .. 6=Sat
    return new Date(y, m - 1, 1).getDay();
  }

  function MonthYearPicker({ value, onChange, placeholder = "Select month" }) {
    // value is "YYYY-MM" or ""
    const now = new Date();
    const initialY = value ? Number(value.slice(0, 4)) : now.getFullYear();
    // const initialM = value ? Number(value.slice(5, 7)) : (now.getMonth() + 1);

    const [open, setOpen] = React.useState(false);
    const [year, setYear] = React.useState(initialY);

    const currY = now.getFullYear();
    const currM = now.getMonth() + 1;

    const ref = React.useRef(null);
    React.useEffect(() => {
      const onDocClick = (e) => {
        if (!ref.current) return;
        if (!ref.current.contains(e.target)) setOpen(false);
      };
      document.addEventListener("mousedown", onDocClick);
      return () => document.removeEventListener("mousedown", onDocClick);
    }, []);

    const label = value ? formatYearMonth(value) : placeholder;

    return (
      <div className="co-picker" ref={ref}>
        <button
          type="button"
          className="completeorders-input co-picker-trigger"
          onClick={() => setOpen((v) => !v)}
        >
          {label}
        </button>

        {open && (
          <div className="co-popover co-month-pop">
            <div className="co-pop-header">
              <button
                className="co-nav"
                onClick={() => setYear((y) => y - 1)}
                aria-label="Previous year"
              >
                ‹
              </button>
              <div className="co-title">{year}</div>
              <button
                className="co-nav"
                onClick={() => setYear((y) => y + 1)}
                aria-label="Next year"
              >
                ›
              </button>
            </div>

            <div className="co-month-grid">
              {[
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
              ].map((name, idx) => {
                const mm = String(idx + 1).padStart(2, "0");
                const isActive = value === `${year}-${mm}`;
                const isCurrent = year === currY && idx + 1 === currM;
                return (
                  <button
                    key={name}
                    type="button"
                    // className={`co-month ${isActive ? "is-active" : ""}`}
                    className={`co-month${isActive ? " is-active" : ""}${
                      isCurrent ? " is-current" : ""
                    }`}
                    onClick={() => {
                      onChange?.(`${year}-${mm}`); // keep value as "YYYY-MM"
                      setOpen(false); // close ONLY when selecting
                    }}
                  >
                    {name}
                  </button>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  }

  function DatePicker({ value, onChange, placeholder = "Select date" }) {
    const today = new Date();
    const initial = parseYMD(value) || {
      y: today.getFullYear(),
      m: today.getMonth() + 1,
      d: today.getDate(),
    };

    const [open, setOpen] = React.useState(false);
    const [viewY, setViewY] = React.useState(initial.y);
    const [viewM, setViewM] = React.useState(initial.m);

    const ref = React.useRef(null);
    React.useEffect(() => {
      const onDocClick = (e) => {
        if (!ref.current) return;
        if (!ref.current.contains(e.target)) setOpen(false);
      };
      document.addEventListener("mousedown", onDocClick);
      return () => document.removeEventListener("mousedown", onDocClick);
    }, []);

    // recompute grid
    const dim = daysInMonth(viewY, viewM);
    const start = firstDow(viewY, viewM); // 0..6
    const cells = [];
    // pad days before 1st
    for (let i = 0; i < start; i++) cells.push(null);
    for (let d = 1; d <= dim; d++) cells.push(d);

    const display = value ? fmtDate(value) : placeholder;

    const goPrevMonth = () => {
      let y = viewY,
        m = viewM - 1;
      if (m === 0) {
        m = 12;
        y--;
      }
      setViewY(y);
      setViewM(m);
    };
    const goNextMonth = () => {
      let y = viewY,
        m = viewM + 1;
      if (m === 13) {
        m = 1;
        y++;
      }
      setViewY(y);
      setViewM(m);
    };

    const selected = parseYMD(value);
    const todayY = today.getFullYear();
    const todayM = today.getMonth() + 1;
    const todayD = today.getDate();

    return (
      <div className="co-picker" ref={ref}>
        <button
          type="button"
          className="completeorders-input co-picker-trigger"
          onClick={() => setOpen((v) => !v)}
        >
          {display}
        </button>

        {open && (
          <div className="co-popover">
            <div className="co-pop-header">
              <button
                className="co-nav"
                onClick={goPrevMonth}
                aria-label="Previous month"
              >
                ‹
              </button>
              <div className="co-title">
                {MONTH_FULL[viewM - 1]}, {viewY}
              </div>
              <button
                className="co-nav"
                onClick={goNextMonth}
                aria-label="Next month"
              >
                ›
              </button>
            </div>

            <div className="co-weekdays">
              {["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map((d) => (
                <div key={d} className="co-wd">
                  {d}
                </div>
              ))}
            </div>

            <div className="co-grid">
              {cells.map((d, i) => {
                const isBlank = d === null;
                const isActive =
                  !!selected &&
                  selected.y === viewY &&
                  selected.m === viewM &&
                  selected.d === d;

                return isBlank ? (
                  <div key={`b-${i}`} className="co-cell is-blank" />
                ) : (
                  <button
                    key={d}
                    type="button"
                    // className={`co-cell ${isActive ? "is-active" : ""}`}
                    className={`co-cell${isActive ? " is-active" : ""}${
                      viewY === todayY && viewM === todayM && d === todayD
                        ? " is-today"
                        : ""
                    }`}
                    onClick={() => {
                      const ymd = `${viewY}-${pad2(viewM)}-${pad2(d)}`;
                      onChange?.(ymd);
                      setOpen(false); // close ONLY on day select
                    }}
                  >
                    {d}
                  </button>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  }
  // ===== Actions: open local modals =====
  // const openReceipt = (order) => setReceiptOrder(order);
  const openRate = (order) => setReviewOrder(order);

  // Export table PDF
  const exportPdf = () => {
    const doc = new jsPDF({ orientation: "landscape" });
    const title = t("completeOrders.reportTitle", {
      defaultValue: "Completed Orders Report",
    });
    doc.setFontSize(16);
    doc.text(title, 14, 14);

    // Exact "D-MMM-YYYY", e.g., 3-Sep-2025
    const MONTH_SHORT = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const prettyDate = (dateLike) => {
      if (!dateLike) return "";
      const d = new Date(dateLike);
      if (isNaN(d)) return "";
      return `${d.getDate()}-${MONTH_SHORT[d.getMonth()]}-${d.getFullYear()}`;
    };

    let rangeLabel = t("completeOrders.allTime", { defaultValue: "All time" });
    if (filterType === "today") {
      rangeLabel = t("completeOrders.today", { defaultValue: "Today" });
    } else if (filterType === "yesterday") {
      rangeLabel = t("completeOrders.yesterday", { defaultValue: "Yesterday" });
    } else if (filterType === "thisMonth") {
      rangeLabel = t("completeOrders.thisMonth", {
        defaultValue: "This Month",
      });
    } else if (filterType === "lastMonth") {
      rangeLabel = t("completeOrders.lastMonth", {
        defaultValue: "Last Month",
      });
    } else if (filterType === "month" && selectedMonth) {
      rangeLabel = formatYearMonth(selectedMonth); // keep your "September, 2025" here
    } else if (filterType === "range" && startDate && endDate) {
      rangeLabel = `${prettyDate(startDate)} - ${prettyDate(endDate)}`;
    }

    doc.setFontSize(11);
    doc.text(
      `${t("completeOrders.range", { defaultValue: "Range" })}: ${rangeLabel}`,
      14,
      22
    );
    doc.text(
      `${t("completeOrders.totalOrders", {
        defaultValue: "Total Orders",
      })}: ${completedCount}`,
      14,
      29
    );
    doc.text(
      `${t("completeOrders.totalEarnings", {
        defaultValue: "Total Earnings",
      })}: ${totalEarnings} Tk`,
      14,
      36
    );

    const rows = filteredOrders.map((o) => {
      const d = getOrderDate(o);
      return [
        o.order_number,
        o.Service?.services_name || "N/A",
        `${o.price} Tk`,
        d ? prettyDate(d) : "", // <-- formatted as D-MMM-YYYY
        o.time || "",
        (o.City || o.usercity || "") +
          (o.Address || o.useraddress ? `, ${o.Address || o.useraddress}` : ""),
        o.status || "",
      ];
    });

    autoTable(doc, {
      startY: 42,
      head: [
        [
          t("completeOrders.orderId"),
          t("completeOrders.service"),
          t("completeOrders.price"),
          t("completeOrders.date"),
          t("completeOrders.time", { defaultValue: "Time" }),
          t("completeOrders.location"),
          t("completeOrders.status"),
        ],
      ],
      body: rows,
      styles: { fontSize: 9 },
      headStyles: { fillColor: [58, 192, 103] },
    });

    doc.save(`completed-orders-${Date.now()}.pdf`);
  };

  // if (loading)
  //   return <p className="completeorders-loading">{t("common.loading")}</p>;

  return (
    <div className="completeorders-container">
      <Loader show={loading} />
      <div className="completeorders-header">
        <h1 className="completeorders-title">{t("completeOrders.heading")}</h1>
      </div>

      {/* ===== Summary Cards + Filters ===== */}
      <div className="completeorders-topbar">
        <div className="completeorders-cards">
          <div className="completeorders-cardmini is-income">
            <div className="completeorders-cardmini-head">
              {/* <span className="completeorders-cardmini-icon">
                <FaMoneyBillWave />
              </span> */}
              <span className="completeorders-cardmini-title">
                {t("completeOrders.totalIncome") || "Total Income"}
              </span>
            </div>
            <div className="completeorders-cardmini-value">
              {totalEarnings} Tk
            </div>
          </div>

          <div className="completeorders-cardmini is-orders">
            <div className="completeorders-cardmini-head">
              {/* <span className="completeorders-cardmini-icon">
                <FaClipboardCheck />
              </span> */}
              <span className="completeorders-cardmini-title">
                {t("completeOrders.completedCount") || "Completed Orders"}
              </span>
            </div>
            <div className="completeorders-cardmini-value">
              {completedCount}
            </div>
          </div>

          {/* <div className="completeorders-cardmini is-avg">
            <div className="completeorders-cardmini-head">
              <span className="completeorders-cardmini-icon">
                <FaChartLine />
              </span>
              <span className="completeorders-cardmini-title">
                {t("completeOrders.avgPerOrder") || "Avg / Order"}
              </span>
            </div>
            <div className="completeorders-cardmini-value">
              {completedCount
                ? Math.round((totalEarnings / completedCount) * 100) / 100
                : 0}{" "}
              Tk
            </div>
          </div> */}
        </div>

        <div className="completeorders-filters">
          <div className="completeorders-filter-row">
            <label className="completeorders-filter-label">
              {t("completeOrders.filterBy") || "Filter by:"}
            </label>

            <select
              value={filterType}
              onChange={(e) => {
                setFilterType(e.target.value);
                setCurrentPage(1);
              }}
              className="completeorders-select"
            >
              <option value="all">
                {t("completeOrders.allTime") || "All time"}
              </option>
              <option value="today">
                {t("completeOrders.today") || "Today"}
              </option>
              <option value="yesterday">
                {t("completeOrders.yesterday") || "Yesterday"}
              </option>
              <option value="thisMonth">
                {t("completeOrders.thisMonth") || "This Month"}
              </option>
              <option value="lastMonth">
                {t("completeOrders.lastMonth") || "Last Month"}
              </option>
              <option value="month">
                {t("completeOrders.byMonth") || "By Month…"}
              </option>
              <option value="range">
                {t("completeOrders.customRange") || "Custom Range…"}
              </option>
            </select>

            {/* {filterType === "month" && (
              <>
              <PickerInput
      mode="month"
      value={selectedMonth}
      onChange={(e) => {
        setSelectedMonth(e.target.value); // "YYYY-MM"
        setCurrentPage(1);
      }}
      placeholder={t("completeOrders.month") || "Select month"}
    />
    {selectedMonth && (
      <span className="co-month-display">
        {formatYearMonth(selectedMonth)}
      </span>
    )}
    </>
    )} */}

            {filterType === "month" && (
              <MonthYearPicker
                value={selectedMonth} // "YYYY-MM" or ""
                onChange={(ym) => {
                  // ym -> "YYYY-MM"
                  setSelectedMonth(ym);
                  setCurrentPage(1);
                }}
                placeholder={t("completeOrders.month") || "Select month"}
              />
            )}

            {/* {filterType === "range" && (
  <>
    <DatePicker
      value={startDate}                   // expects "YYYY-MM-DD" or ""
      onChange={(d) => {                  // d is "YYYY-MM-DD"
        setStartDate(d);
        setCurrentPage(1);
      }}
      placeholder={t("completeOrders.fromDate") || "Select From date"}
    />
    <span className="completeorders-dash">—</span>
    <DatePicker
      value={endDate}
      onChange={(d) => {
        setEndDate(d);
        setCurrentPage(1);
      }}
      placeholder={t("completeOrders.toDate") || "Select To date"}
    />
  </>
)} */}

            {filterType === "range" && (
              <div className="co-range">
                <DatePicker
                  value={startDate}
                  onChange={(d) => {
                    setStartDate(d);
                    setCurrentPage(1);
                  }}
                  placeholder={
                    t("completeOrders.fromDate") || "Select From date"
                  }
                />
                <span className="co-range-dash">—</span>
                <DatePicker
                  value={endDate}
                  onChange={(d) => {
                    setEndDate(d);
                    setCurrentPage(1);
                  }}
                  placeholder={t("completeOrders.toDate") || "Select To date"}
                />
              </div>
            )}

            <button className="completeorders-export" onClick={exportPdf}>
              {t("completeOrders.downloadPdf") || "Download PDF"}
            </button>
            <button
              className="completeorders-reset"
              onClick={() => {
                setFilterType("all");
                setStartDate("");
                setEndDate("");
                setSelectedMonth("");
                setCurrentPage(1);
              }}
            >
              {t("completeOrders.reset") || "Reset"}
            </button>
          </div>
        </div>
      </div>

      {/* ===== Table / Cards ===== */}
      {completedOrders.length === 0 ? (
        <p className="completeorders-empty">{t("completeOrders.noOrders")}</p>
      ) : (
        <>
          <div className="completeorders-content">
            {/* Desktop table */}
            <div className="completeorders-desktop">
              <div className="completeorders-table-wrapper">
                <table className="completeorders-table">
                  <thead>
                    <tr>
                      <th className="completeorders-th">
                        {t("completeOrders.orderId")}
                      </th>
                      <th className="completeorders-th">
                        {t("completeOrders.service")}
                      </th>
                      <th className="completeorders-th">
                        {t("completeOrders.price")}
                      </th>
                      <th className="completeorders-th">
                        {t("completeOrders.dateTime")}
                      </th>
                      <th className="completeorders-th">
                        {t("completeOrders.location")}
                      </th>
                      <th className="completeorders-th">
                        {t("completeOrders.status")}
                      </th>
                      <th className="completeorders-th">
                        {t("completeOrders.actions")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentOrders.map((order, idx) => {
                      const allowRate =
                        order.status === "Completed" &&
                        !hasServitorReviewed(order);

                      return (
                        <tr key={idx} className="completeorders-row">
                          <td className="completeorders-td">
                            {order.order_number}
                          </td>
                          <td className="completeorders-td">
                            {order.Service?.services_name || "N/A"}
                          </td>
                          <td className="completeorders-td completeorders-price">
                            {order.price} Tk
                          </td>
                          <td className="completeorders-td">
                            <div>{formatDate(order.date)}</div>
                            <div className="completeorders-time">
                              {order.time}
                            </div>
                          </td>
                          <td className="completeorders-td">
                            <div className="completeorders-city">
                              {order.City || order.usercity || "Unknown"}, {order.Area || order.userarea || "Unknown"}
                            </div>
                            <div className="completeorders-address">
                              {order.Address || order.useraddress || "Unknown"}
                            </div>
                          </td>
                          <td className="completeorders-td">
                            <span className="completeorders-status">
                              {order.status}
                            </span>
                          </td>
                          <td className="completeorders-td">
                            <div className="completeorders-actions">
                              {/* <button
                                className="completeorders-btn completeorders-btn-receipt"
                                onClick={() => openReceipt(order)}
                                title={t("completeOrders.receipt") || "Receipt"}
                              >
                                <FaDownload style={{ marginRight: 6 }} />
                                {t("completeOrders.receipt") || "Receipt"}
                              </button> */}


                              {/* <button
                                className="completeorders-btn completeorders-btn-rate"
                                onClick={() => openRate(order)}
                                disabled={!allowRate}
                                title={
                                  allowRate
                                    ? (t("completeOrders.rate") || "Rate")
                                    : (order.hasReview ? (t("completeOrders.alreadyRated") || "Already rated") : (t("completeOrders.rateWhenCompleted") || "Allowed when completed"))
                                }
                              >
                                <FaStar style={{ marginRight: 6 }} />
                                {order.hasReview
                                  ? (t("completeOrders.rated") || "Rated")
                                  : (t("completeOrders.rate") || "Rate")}
                              </button> */}

                              {allowRate && (
                                <button
                                  className="completeorders-btn completeorders-btn-rate"
                                  onClick={() => openRate(order)}
                                  title={t("completeOrders.rate") || "Rate"}
                                >
                                  <FaStar style={{ marginRight: 6 }} />
                                  {t("completeOrders.rate") || "Rate"}
                                </button>
                              )}

                              <button
                                className="completeorders-btn completeorders-btn-manage"
                                onClick={() => navigate(`/servitor/orders/${order.order_number}`)}
                                // title="Manage Order"
                                title={t("orderHistory.tooltips.manageOrder")}
                              >
                                {/* Manage */}
                                {t("orderHistory.buttons.manage")}
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Mobile cards */}
            <div className="completeorders-mobile">
              {currentOrders.map((order, idx) => {
                const allowRate =
                  order.status === "Completed" && !hasServitorReviewed(order);

                return (
                  <div key={idx} className="completeorders-card">
                    <div className="completeorders-card-header">
                      <div>
                        <h3 className="completeorders-card-title">
                          {order.order_number}
                        </h3>
                        <p className="completeorders-card-service">
                          {order.Service?.services_name || "N/A"}
                        </p>
                      </div>
                      <div className="completeorders-card-right">
                        <p className="completeorders-card-price">
                          {order.price} Tk
                        </p>
                        <span className="completeorders-status">
                          {order.status}
                        </span>
                      </div>
                    </div>
                    <div className="completeorders-card-body">
                      <div className="completeorders-card-item">
                        <span className="completeorders-card-label">
                          {t("completeOrders.dateTime")}
                        </span>
                        <span className="completeorders-card-value">
                          {formatDate(order.date)} at {order.time}
                        </span>
                      </div>
                      <div className="completeorders-card-item">
                        <span className="completeorders-card-label">
                          {t("completeOrders.location")}
                        </span>
                        <div className="completeorders-card-value">
                          <div>{order.City || order.usercity || "Unknown"}, {order.Area || order.userarea || "Unknown"}</div>
                          <div className="completeorders-card-address">
                            {truncateAddress(
                              order.Address || order.useraddress || "Unknown"
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="completeorders-actions">
                      {/* <button
                        className="completeorders-btn completeorders-btn-receipt"
                        onClick={() => openReceipt(order)}
                        title={t("completeOrders.receipt") || "Receipt"}
                      >
                        <FaDownload style={{ marginRight: 6 }} />
                        {t("completeOrders.receipt") || "Receipt"}
                      </button> */}


                      {/* <button
                        className="completeorders-btn completeorders-btn-rate"
                        onClick={() => openRate(order)}
                        disabled={!allowRate}
                        title={
                          allowRate
                            ? (t("completeOrders.rate") || "Rate")
                            : (order.hasReview ? (t("completeOrders.alreadyRated") || "Already rated") : (t("completeOrders.rateWhenCompleted") || "Allowed when completed"))
                        }
                      >
                        <FaStar style={{ marginRight: 6 }} />
                        {order.hasReview
                          ? (t("completeOrders.rated") || "Rated")
                          : (t("completeOrders.rate") || "Rate")}
                      </button> */}

                      {allowRate && (
                        <button
                          className="completeorders-btn completeorders-btn-rate"
                          onClick={() => openRate(order)}
                          title={t("completeOrders.rate") || "Rate"}
                        >
                          <FaStar style={{ marginRight: 6 }} />
                          {t("completeOrders.rate") || "Rate"}
                        </button>
                      )}

                      <button
                        className="completeorders-btn completeorders-btn-manage"
                        onClick={() => navigate(`/servitor/orders/${order.order_number}`)}
                      >
                        Manage
                    </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="completeorders-summary">
            {t("completeOrders.paginationSummary", {
              startOrder,
              endOrder,
              totalOrders,
            })}
          </div>

          <div className="completeorders-pagination">
            <Pagination>
              <Pagination.First
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
              />
              <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                {t("completeOrders.previousPage")}
              </Pagination.Prev>
              <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                {t("completeOrders.nextPage")}
              </Pagination.Next>
              <Pagination.Last
                onClick={() => handlePageChange(totalPages)}
                disabled={currentPage === totalPages}
              />
            </Pagination>
          </div>
        </>
      )}

      {/* ===== Local Modals ===== */}
      {/* {reviewOrder && (
        <ServitorReviewModal
          order={reviewOrder}
          onClose={() => setReviewOrder(null)}
          onReviewSubmit={() => {
            // Optimistically mark as reviewed in the list
            setCompletedOrders((prev) =>
              prev.map((o) =>
                o.order_number === reviewOrder.order_number
                  ? { ...o, hasReview: true }
                  : o
              )
            );
            setReviewOrder(null);
          }}
        />
      )} */}

      {reviewOrder && (
        <ServitorReviewModal
          order={reviewOrder}
          onClose={() => setReviewOrder(null)}
          onReviewSubmit={() => {
            // either a full reload:
            window.location.reload();

            // or, if you prefer no full reload:
            // setCompletedOrders(prev => prev.map(o => o.order_number === reviewOrder.order_number ? { ...o, hasReview: true } : o));
            // setReviewOrder(null);
          }}
        />
      )}

      {receiptOrder && (
        <ServitorReceiptGenerator
          order={receiptOrder}
          onFinish={() => setReceiptOrder(null)} // close after download/print
        />
      )}
    </div>
  );
};

export default CompleteOrders;
